<template>
  <navbar v-model="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-minimize">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" @click="minimizeSidebar">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle">
        <navbar-toggle-button @click.native="toggleSidebar">

        </navbar-toggle-button>
      </div>
      <p class="navbar-brand">{{$t('routes.' + $route.name)}}</p>
    </div>
    <div v-if="PickerConfig" class="ml-2">
      <Picker
        v-if="PickerPermissions"
        :route="PickerConfig.route"
        :params="PickerConfig.params"
      ></Picker>
    </div>
    <div v-else-if="DatePickerConfig" class="ml-2">
      <DatePicker></DatePicker>
    </div>
    <template slot="navbar-menu">
      <b-navbar-nav>
        <b-nav-item-dropdown
          v-if="hasOwnerRoles"
          right
          split
          split-variant="outline-primary"
          variant="primary"
          class="m-2"
        >
          <template #button-content>
            <i class="nc-icon nc-settings-gear-65"></i>
          </template>
          <router-link
            tag="b-dropdown-item-button"
            to="/aclconfiguration">
            {{ $t('menu.aclconfiguration.show') }}
          </router-link>
          <router-link
            tag="b-dropdown-item-button"
            to="/appconfiguration">
            {{ $t('menu.appconfiguration.show') }}
          </router-link>
          <router-link
            tag="b-dropdown-item-button"
            to="/admin/clienttypes/list">
            {{ $t('buttons.clienttypesconfiguration') }}
          </router-link>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </template>
  </navbar>
</template>
<script>
import { Navbar, NavbarToggleButton } from 'src/components/UIComponents'
import { checkPermission, getUserRoles } from '@/utils/checkRoles'
import Picker from '@/components/Dashboard/Layout/Picker'
import DatePicker from '@/components/Dashboard/Layout/DatePicker'

export default {
  components: {
    Navbar,
    NavbarToggleButton,
    Picker,
    DatePicker
  },
  data () {
    return {
      activeNotifications: false,
      showNavbar: false
    }
  },
  created () {
  },
  computed: {
    hasOwnerRoles () {
      const roles = getUserRoles().roles
      return roles.includes('ROLE_OWNER') || roles.includes('ROLE_SUPER_USER')
    },
    PickerPermissions () {
      if (this.$route.path.includes('timetable/dashboard')) {
        return this.hasOwnerRoles
      }
      return true
    },
    DatePickerConfig () {
      return this.$route.path.includes('daily_plan/show')
    },
    PickerConfig () {
      if (this.$route.path.includes('timetable/dashboard')) {
        return {
          route: 'user_datas/list',
          params: {
            idClientType: [...this.$store.getters['configuration/customClientTypeIds'], 3, 4, 5, 8, 14, 15, 16],
            state: 1
          }
        }
      } else if (this.$route.name === 'FirmShow') {
        return {
          route: 'user_datas/list',
          params: {
            isCompany: 1,
            state: 1
          }
        }
      } else {
        return false
      }
    }
  },
  methods: {
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    toggleNotificationDropDown () {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown () {
      this.activeNotifications = false
    },
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar () {
      this.$sidebar.displaySidebar(false)
    },
    minimizeSidebar () {
      this.$sidebar.toggleMinimize()
    },
    toggleNavbar () {
      this.showNavbar = !this.showNavbar
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    }
  }
}

</script>
<style>

</style>
